var cilArrowThickFromRight = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M254.625,56H215.993L16,256.2,216,456h38.623V336h144V176h-144Zm112,152v96h-144V417.384L61.255,256.174,222.625,94.639V208Z' class='ci-primary'/><rect width='32' height='400' x='462.625' y='56' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickFromRight };

